function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import BoardsAndQuotesCarouselComponent from "/components/core/boards-and-quotes-carousel/boards-and-quotes-carousel-component";
import SwitchingTitleWithSignupComponent from "/components/core/switching-title-with-signup/switching-title-with-signup-component";
import classnames from "classnames";
import { StyledSwitchingTitleWithQuotesCarouselComponent } from "./switching-title-with-quotes-carousel-component.scss";
class SwitchingTitleWithQuotesCarouselComponent extends PureComponent {
    componentDidMount() {
        const { animationInterval } = this.props;
        if (animationInterval) {
            this.setIncrementActiveIndexInterval();
        } else {
            this.clearIncrementActiveIndexInterval();
        }
    }
    setIncrementActiveIndexInterval() {
        const { animationInterval } = this.props;
        this.clearIncrementActiveIndexInterval();
        this.incrementActiveIndexInterval = setInterval(this.incrementActiveIndex, animationInterval);
    }
    incrementActiveIndex() {
        const { activeIndex } = this.state;
        const { useCases } = this.props;
        const nextActiveIndex = (activeIndex + 1) % useCases.length;
        this.setActive(nextActiveIndex);
    }
    setActive(activeIndex) {
        this.setState({
            activeIndex
        });
    }
    onCaruoselActiveChange(activeIndex) {
        this.clearIncrementActiveIndexInterval();
        this.setActive(activeIndex);
    }
    componentWillUnmount() {
        this.clearIncrementActiveIndexInterval();
    }
    clearIncrementActiveIndexInterval() {
        if (this.incrementActiveIndexInterval) {
            clearInterval(this.incrementActiveIndexInterval);
        }
    }
    render() {
        const { useCases, title, subtitle, mobileTitle, showSignup, showSubtitle, showNavigationArrows, removeBoardBorder, aboveTheFold, signupForm, isMobileOrTabletBrowser } = this.props;
        const useAboveTheFoldLayout = aboveTheFold && !isMobileOrTabletBrowser;
        const activeIndex = Math.min(useCases.length - 1, this.state.activeIndex);
        if (!useCases[activeIndex]) return false;
        const switchingWords = {
            wordWidth: "124px",
            words: useCases.map((uc, i)=>_object_spread_props(_object_spread({}, uc.word), {
                    color: useCases[i].color
                }))
        };
        const stopAutoSlide = this.clearIncrementActiveIndexInterval;
        const startAutoSlide = this.setIncrementActiveIndexInterval;
        const showArrowsInQuotes = showNavigationArrows;
        return /*#__PURE__*/ _jsxs(StyledSwitchingTitleWithQuotesCarouselComponent, {
            className: classnames("switching-title-with-quotes-carousel-component", {
                "above-the-fold": useAboveTheFoldLayout
            }),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "switching-title-with-signup-wrapper",
                    children: /*#__PURE__*/ _jsx(SwitchingTitleWithSignupComponent, {
                        title: title,
                        subtitle: subtitle,
                        switchingWords: switchingWords,
                        activeIndex: activeIndex,
                        mobileTitle: mobileTitle,
                        showSignup: showSignup,
                        showSubtitle: showSubtitle,
                        aboveTheFold: useAboveTheFoldLayout,
                        signupForm: signupForm
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "boards-and-quotes-carousel-wrapper",
                    children: /*#__PURE__*/ _jsx(BoardsAndQuotesCarouselComponent, {
                        quotes: useCases,
                        activeIndex: activeIndex,
                        setActive: this.onCaruoselActiveChange,
                        stopAutoSlide: stopAutoSlide,
                        startAutoSlide: startAutoSlide,
                        showNavigationArrows: showArrowsInQuotes,
                        removeBoardBorder: removeBoardBorder,
                        aboveTheFold: useAboveTheFoldLayout
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.setActive = this.setActive.bind(this);
        this.onCaruoselActiveChange = this.onCaruoselActiveChange.bind(this);
        this.incrementActiveIndex = this.incrementActiveIndex.bind(this);
        this.clearIncrementActiveIndexInterval = this.clearIncrementActiveIndexInterval.bind(this);
        this.setIncrementActiveIndexInterval = this.setIncrementActiveIndexInterval.bind(this);
        this.incrementActiveIndexInterval = null;
        this.state = {
            activeIndex: 0
        };
    }
}
export { SwitchingTitleWithQuotesCarouselComponent as default };
SwitchingTitleWithQuotesCarouselComponent.defaultProps = {
    title: "A new way to manage your",
    subtitle: "Plan, organize and track your work. All in one visual collaborative place",
    useCases: [
        {
            boardImage: "/static/img/community/board-image3.jpg",
            personTitle: "Bla Bla",
            personImage: "/static/img/exit-popup/exit-popup-social-proof-person-avater.png",
            quoteText: '"It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more "',
            active: true,
            word: {
                text: "workflows"
            },
            color: "brand-red"
        },
        {
            boardImage: "/static/img/lp/fb/designers-long/timeline.png20180125-30832-j2m2hz.png",
            personImage: "/static/img/jobs-page/cs.png",
            personTitle: "Tan Ha",
            quoteText: '"It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged"',
            active: false,
            word: {
                text: "work"
            },
            color: "brand-blue"
        },
        {
            boardImage: "/static/img/community/board-image2.jpg",
            personImage: "/static/img/jobs-page/design.png",
            personTitle: "Product Designer",
            quoteText: "123qweqwedawa dwkdj awkdj aw;kdj akw;ldj aw;kdj aw;kdj aklw;djaklw;d jawkld jakl;wdj ak;lwdj ",
            active: false,
            word: {
                text: "clients"
            },
            color: "brand-green"
        },
        {
            boardImage: "/static/img/s/car-manufacturing-management/high-level-board.png",
            personImage: "/static/img/s/construction-management-software/original-real_photo.png",
            personTitle: "Dude",
            quoteText: '"Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book"',
            active: false,
            word: {
                text: "tasks"
            },
            color: "brand-purple"
        },
        {
            personTitle: "Tal",
            quoteText: "dawd awdawdaw da wd awd awd aw daw dawd",
            personImage: "/static/img/s/multitasking-work-productivity/Picture1.png",
            boardImage: "/static/img/s/agile-management-software/project_status.png",
            active: false,
            word: {
                text: "blabla"
            },
            color: "brand-iris"
        }
    ],
    animationInterval: "3000",
    paddingTop: "100px"
};
SwitchingTitleWithQuotesCarouselComponent.baseSegmentStyleOverride = {
    paddingLeft: 0,
    paddingRight: 0
};
